module.exports = __webpack_public_path__ + "h5/img/b2.25f7c640.jpeg";